export default "__VITE_ASSET__BHjdta43__"